import ThumbnailGallery from './ThumbnailGallery';

export default ThumbnailGallery;
